import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/queryClient.ts';
import { RouterProvider } from 'react-router';
import { createAppRouter } from './router.tsx';
import { createSiteRouter } from './site/siteRouter.tsx';
import { AuthProvider } from './lib/auth.tsx';
import { DialogHost } from './components/ui/Dialog.tsx';
import { ToastHost } from './components/ui/Toast.tsx';
import { isCustomDomain, isSiteHost } from './lib/hosts.ts';
import { lockTenantToHost } from './lib/tenant.ts';
import './index.css';

// CR-040: 라우터는 경로가 아니라 호스트로 고른다. 사이트 호스트(isms-p.kr·www)는 서비스 사이트, 그 밖(app.isms-p.kr·커스텀 도메인·localhost)은 웹앱.
const isApp = !isSiteHost();
document.documentElement.classList.toggle('site', !isApp);

async function boot() {
  const root = createRoot(document.getElementById('root')!);
  if (isApp && isCustomDomain()) {
    // 검증된 커스텀 도메인이면 호스트가 조직을 확정한다 (조직 ID 단계 생략, 조직 변경 불가)
    try {
      const r = await fetch('/api/public/host-tenant', { headers: { Accept: 'application/json' } });
      if (r.ok) { const t = (await r.json()) as { custom: boolean; slug?: string }; if (t.custom && t.slug) lockTenantToHost(t.slug); }
      else if (r.status === 404) {
        root.render(<div style={{ padding: 48, fontFamily: 'system-ui, sans-serif', color: '#334155' }}><h1 style={{ fontSize: 20, marginBottom: 8 }}>등록되지 않은 도메인입니다</h1><p>이 주소({window.location.hostname})는 PRISM 에 연결된 조직이 없습니다. 조직 관리자에게 도메인 설정을 확인해 달라고 요청하세요.</p></div>);
        return;
      }
    } catch { /* API 를 못 받으면 일반 앱 흐름(조직 ID 단계)으로 */ }
  }
  root.render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        {isApp ? (
          <AuthProvider>
            <RouterProvider router={createAppRouter()} />
            <DialogHost />
            <ToastHost />
          </AuthProvider>
        ) : <RouterProvider router={createSiteRouter()} />}
      </QueryClientProvider>
    </StrictMode>,
  );
}
void boot();
